export interface ILoanQuoteKeyParams {
  loanQuoteID: string;
}

export const loanQuoteKeys = {
  loanQuoteRequirements: (params: ILoanQuoteKeyParams) =>
    ['loan quotes requirements', params.loanQuoteID] as const,
};

export function parseLoanQuoteKey<T extends keyof typeof loanQuoteKeys>(
  queryKey: ReturnType<(typeof loanQuoteKeys)[T]>
) {
  const [, loanQuoteID] = queryKey;

  return { loanQuoteID };
}
